export interface OverlayPanelPosition {
  top: number;
  left: number;
  width: number;
  constrainedDimensions?: ConstrainedDimensions;
}

export type ConstrainedDimensions = {
  width?: number;
  height?: number;
};

export enum OverlayScrollDetectionType {
  Parent,
  All,
}
